// Code/src/Components/BankingAndSecureInfo/PayStub/MyPayments.tsx
import React from "react";
import { Card, CardContent } from "../../ui/card";

const iframeUrl =
  "https://pbsapps.teampbs.com/timeentry/client/#/entries-recent?isdlg=1";

const iframeStyles: React.CSSProperties = {
  border: "none",
  width: "100%",
  height: "80vh",
};

const MyPayments: React.FC = () => {
  return (
    <Card className="w-full">
      <CardContent className="p-0">
        <iframe title="My Payments" src={iframeUrl} style={iframeStyles} />
      </CardContent>
    </Card>
  );
};

export default MyPayments;
